export enum MethodEvaluationEnum {
  None = 0,
  Best = 1,
  Supporting = 2,
  Exclude = 3,
}
